import SectionHeader from '@components/ui/SectionHeader'
import styles from './styles.module.scss'
import ComparisonCard, { ComparisonCardProps } from './ComparisonCard'
import ScrollCarousel from '@components/ui/ScrollCarousel'
import { CSSProperties } from 'react'

export type ComparisonCardsProps = {
  title: string
  byline?: string
  cards: {
    [key: number]: ComparisonCardProps
  }
}

export default function ComparisonCards(props: ComparisonCardsProps) {
  const { title, cards } = props

  if (!cards) return null

  const cardsStyle = {
    '--slide-length': `${Object.values(cards).length - 1}px`
  } as CSSProperties

  return (
    <div className={styles.ComparisonCards}>
      <div className={styles.ComparisonCards__wrapper}>
        <SectionHeader
          title={title}
          variant="left_aligned"
          className={styles.ComparisonCards__title}
        />

        <div className={styles.ComparisonCards__cards} style={cardsStyle}>
          <ScrollCarousel
            carouselClasses={styles.ComparisonCards__carousel}
            classes={styles.ComparisonCards__scrollCarousel}
            settings={{
              buttons: {
                visible: {
                  mobile: false,
                  desktop: Object.values(cards).length > 2
                },
                position: 'bottom'
              },
              loop: false,
              overflow: false,
              progressBar: {
                visible: {
                  mobile: true,
                  desktop: Object.values(cards).length > 2
                }
              },
              plugins: {
                fade: false,
                autoHeight: false
              }
            }}
          >
            {Object.values(cards).map((card, index) => (
              <ComparisonCard {...card} key={`${card.title}-${index}`} />
            ))}
          </ScrollCarousel>
        </div>
      </div>
    </div>
  )
}
